// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Traducoes_RetraduzirInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/traducoes/retraduzir.
 *
 * `chave` absent retranslates the WHOLE page — one Google call per line per
 * language, so it is the expensive branch on purpose.
 */
import { registerContract } from './validate'

export interface Traducoes_RetraduzirInput {
pagina?: string
chave?: string
}

registerContract('Traducoes_RetraduzirInput', {
  pagina: { type: 'string',  required: false },
  chave:  { type: 'string',  required: false },
})
